import * as React from 'react';

import * as styles from './styles.css';
import { ScrollableWrapper } from '../../commonComponents';
import { NarrowOfferRow } from '../NarrowOfferRow';
import { IOffersFeedProps } from '../../../../containers/types';

type TNarrowOffersFeedProps = Omit<IOffersFeedProps, 'feedViewState'>;

export const NarrowOffersFeed: React.FC<TNarrowOffersFeedProps> = ({
  scrollable,
  data,
  onOfferClick,
  showMoreBtn,
  selectable,
  activeOfferId,
  viewedOffers,
}) => {
  const content = (
    <div className={styles['content']}>
      {data.map(offer => (
        <NarrowOfferRow
          key={offer.id}
          data={offer}
          onClick={() => onOfferClick(offer.id)}
          selectable={selectable}
          isActive={offer.id === activeOfferId}
          isViewed={viewedOffers.includes(offer.id)}
        />
      ))}
      {showMoreBtn}
    </div>
  );

  return scrollable ? <ScrollableWrapper>{content}</ScrollableWrapper> : content;
};
